module.exports = __webpack_public_path__ + "static/media/Bluelab PeriPod M3.73cc7451.webp";